import * as types from "./actions";

const defaultState = {
    list: [],
    tableHeader:[
        {
            label: "履歴No", 
            button:false,
            rightAlign: true
        },
        {
            label: "アップロード日時", 
            button:false
        },
        {
            label: "件数", 
            button:false,
            rightAlign: true
        },
        {
            label: "エラー", 
            button:false,
            rightAlign: true
        },
        {
            label: "内容",
            button:true
        },
    ],
    tableColumns:[
        "uploadNo",
        "uploadDttmDisplay",
        "countDisplay",
        "errorDisplay"
    ],
    viewList: [],
    tableViewHeader:[
        {
            label: "行No", 
            button:false,
            rightAlign: true
        },
        {
            label: "取引先名", 
            button:false
        }, 
        {
            label: "商品名", 
            button:false
        },
               
        {
            label: "納品日", 
            button:false
        },
        {
            label: "数量", 
            button:false,
            rightAlign: true
        },
        {
            label: "状況",
            button:false
        },
    ],
    tableViewColumns:[
        "uploadLineNo",
        "shopName",
        "productName",        
        "deliveryDt",
        "quantity",
        "errorMessage"
    ],
    
}

export default function reducer (state=defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return {...state, list: action.payload};
        case types.DETAILS_LIST:
            return {...state, viewList: action.payload};
        default: // need this for default case
            return state 
    }
};
